import styled from "styled-components";
import { FiPlus } from "react-icons/fi";

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 0;

  @media (max-width: 960px) {
    padding: 10px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
  @media (max-width: 960px) {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`;

export const CollapseToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  color: #008394;
`;

export const MenuItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;
  background-color: ${(props) => (props.active ? "#f0f0f0" : "transparent")};
  border-radius: 5px;
  margin-bottom: 5px;
  transition: background 0.2s;

  &:hover {
    background-color: #eaeaea;
  }
`;

export const Body = styled.div`
  width: 70%;
  height: 100%;
  background: #F5F5F5;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  @media (max-width: 960px) {
    width: 95%;
    padding: 10px;
    border-radius: 8px;
    margin: 10px;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* allows wrapping on smaller screens */
  gap: 10px;
  margin-bottom: 20px;

  h1 {
    margin: 0;
    flex: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    h1 {
      width: 100%;
      margin-bottom: 10px;
    }
  }
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block; /* Removes any default spacing */
  border-radius: 8px;
  transition: transform 0.3s ease; /* Smooth transition for any hover effects */
  
  /* Optional: add a subtle shadow for depth */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    border-radius: 6px; /* Slightly smaller radius on mobile */
  }
`;

// The BannerHeader component
export const BannerHeader = ({ program, bannerPath }) => {
  return (
    <HeaderInfo>
      <BannerImage
        src={bannerPath || "/banner.jpg"}
        alt={program.name}
      />
    </HeaderInfo>
  );
};


export const SearchBox = styled.div`
  margin-top: 10px;
  input {
    width: 93%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
`;

export const Section = styled.div`
  margin-top: 30px;

  h3 {
    margin-bottom: 10px;
  }

  p {
    line-height: 1.6;
  }
`;

export const ViewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
`;

export const ViewCard = styled.div`
  background: ${(props) => (props.isSelected ? "#d4edda" : "#f7f7f7")};
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background: #e9f5ec;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  }
`;

export const ViewCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  p {
    font-size: 14px;
    color: #666;
  }
  span {
    font-size: 12px;
    color: #999;
  }
`;

export const ViewCardActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  
  svg {
    width: 18px;
    height: 18px;
    color: #666;
  }
`;

export const ButtonTooltip = styled.span`
  position: absolute;
  bottom: -30px;
  right: 0;
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  
  ${IconButton}:hover & {
    opacity: 1;
    visibility: visible;
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Button = styled.button`
  background-color: #008394;
  color: white;
  border: none;
  padding: 12px 24px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;

  &:hover {
    background-color: #EEA746;
    color: #F5F5F5;
  }
`;

export const ButtonRed = styled.button`
  background-color: #c52a2a;
  color: white;
  border: none;
  padding: 12px 24px;
  margin-top: 20px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;

  &:hover {
    background-color: #45a049;
  }
`;

export const PaginationWrapper = styled.div`
  margin-top: 20px;
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 15px;
  overflow-y: auto;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  border-radius: 5px;
  overflow-y: auto;
  
  @media (max-width: 900px) {
    width: 95%;
    padding: 15px;
  }
  
  @media (max-width: 600px) {
    padding: 10px;
    max-height: 85vh;
  }
`;

export const FormField = styled.div`
  margin-bottom: 20px;
  label {
    display: block;
    margin-bottom: 10px;
    font-weight: bold;
  }
  input,
  textarea {
    width: 93%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  button {
    padding: 10px 20px;
    background-color: #8A2BE2;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
`;

export const SelectBox = styled.select`
  width: 95.6%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: border 0.3s;
  &:focus {
    border-color: #8A2BE2;
  }
  @media (max-width: 960px) {
     width: 100%;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  border: none;
  cursor: pointer;
  color: #333;
`;

export const SkillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
`;

export const Skill = styled.span`
  background-color: #f1f1f1;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 14px;
  color: #8A2BE2;
  font-weight: bold;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e0e0e0;
    cursor: pointer;
  }
`;

export const FileInput = styled.div`
  display: flex;
  flex-direction: column;
  input {
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 14px;
    margin-bottom: 8px;
    outline: none;
    cursor: pointer;
    transition: border 0.3s;
    &:focus {
      border-color: #8A2BE2;
    }
  }
  span {
    font-size: 14px;
    color: #888;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const PromptContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: lefct;
  background: #f9fafc;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  margin: 0 auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const PromptMessage = styled.div`
  margin-bottom: 20px;

  h2 {
    font-size: 24px;
    color: #333;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    color: #666;
    line-height: 1.5;
  }
`;

export const StyledButton = styled(Button)`
  && {
    font-size: 16px;
    padding: 10px 20px;
    border-radius: 5px;
    text-transform: none;
  }
`;


export const PageWrapper = styled.div`
  min-height: 540px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: center;
  background: white;
  padding: 20px;
  border-radius: 5px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
`;

export const Input = styled.input`
  padding: 15px;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #bacad3;
  &:focus {
    outline: none;
    border-color: #49cb86;
    color: #4A4A4A;
  }
`;

export const Message = styled.p`
  margin-top: 20px;
  a {
    color: #008394;
    text-decoration: underline;
  }
`;

export const StatusMessage = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: ${(props) => (props.type === "success" ? "#28a745" : "#dc3545")};
  text-align: center;
  font-weight: bold;
`;


export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledInput = styled.input`
  padding: 15px;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #bacad3;
  width: 84%;
  padding-right: 40px; /* Make room for the icon */
  
  &:focus {
    outline: none;
    border-color: #49cb86;
    color: #4A4A4A;
  }
  @media (max-width: 960px) {
    width: 77%;
  }
`;

export const ToggleIcon = styled.div`
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6e7a83;
  
  &:hover {
    color: #49cb86;
  }
`;

export const GoogleButton = styled.button`
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: white;
  color: #4a4a4a;
  border: 1px solid #bacad3;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8f8f8;
    border-color: #9facb3;
  }

  &:focus {
    outline: none;
    border-color: #49cb86;
  }
`;


export const LoginButton = styled.button`
  padding: 10px 20px;
  background-color: #8A2BE2;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #45a049;
  }
`;

export const SubmitButton = styled.button`
  padding: 10px 20px;
  background-color: #8A2BE2;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    font-size: 16px;
    margin-bottom: 10px;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  textarea {
    resize: none;
  }
`;

export const TalentDetails = styled.div`
  margin-bottom: 50px;
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
`;

export const DetailItem = styled.div`
  flex: 1;
  min-width: 250px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #008394;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: #EEA746;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  span {
    margin-left: 8px;
  }
  
  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 14px;
  }
`;

export const PlusIcon = styled(FiPlus)`
  font-size: 18px;
  stroke-width: 2.5;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CardTitle = styled.h4`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
`;

export const CardMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
`;

export const MetaIcon = styled.span`
  margin-right: 6px;
  display: flex;
  align-items: center;
  
  svg {
    font-size: 14px;
    color: #555;
  }
`;

export const Deadline = styled(MetaItem)`
  display: flex;
  align-items: center;
`;

export const DeadlineDate = styled.span`
  font-weight: 500;
  margin-left: 4px;
`;

export const DeadlineAlert = styled.span`
  display: flex;
  align-items: center;
  margin-left: 10px;
  background: #fff3cd;
  color: #856404;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
`;

export const AlertIcon = styled.span`
  margin-right: 4px;
  display: flex;
  align-items: center;
  
  svg {
    color: #856404;
  }
`;